import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPhotoLibrary = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-96.00 -122.18 1600.00 2036.36",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1404 151Q1404 34 1325.0 -45.0Q1246 -124 1129 -124Q994 -124 894 -24L117 752Q4 867 4 1023Q4 1182 114.0 1293.0Q224 1404 383 1404Q541 1404 656 1291L1261 685Q1271 675 1271 663Q1271 647 1240.5 616.5Q1210 586 1194 586Q1181 586 1171 596L565 1203Q486 1280 384 1280Q278 1280 205.0 1205.0Q132 1130 132 1024Q132 919 208 843L984 66Q1047 3 1129 3Q1193 3 1235.0 45.0Q1277 87 1277 151Q1277 233 1214 296L633 877Q607 901 573 901Q544 901 525.0 882.0Q506 863 506 834Q506 802 531 775L941 365Q951 355 951 343Q951 327 920.0 296.0Q889 265 873 265Q861 265 851 275L441 685Q378 746 378 834Q378 916 435.0 973.0Q492 1030 574 1030Q662 1030 723 967L1304 386Q1404 288 1404 151Z"
	})
});
export default SvgPhotoLibrary;
